import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

interface PageLayoutProps {
  children: React.ReactNode;
  /** Ancho máximo del contenido (opcional). Por defecto 320. */
  maxWidth?: number | string;
}

/**
 * Layout común para páginas del autocotizador (Error, Success, etc.).
 * Incluye AppBar con logo y caja central para el contenido.
 */
const PageLayout: React.FC<PageLayoutProps> = ({ children, maxWidth = 320 }) => (
  <Box
    sx={{
      bgcolor: '#f5f5f5',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <AppBar position="static" sx={{ bgcolor: '#003C82' }}>
      <Toolbar>
        <Box
          component="img"
          src="/logo-coordinadora.svg"
          alt="Logo Coordinadora"
          sx={{
            width: 'auto',
            height: 60,
            mr: 2,
            display: 'block',
          }}
        />
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          AUTOCOTIZADOR
        </Typography>
        <Box sx={{ bgcolor: '#1063AC', px: 2, py: 0.5, borderRadius: 1 }}>
          <Typography variant="body2" color="white">
            AutoCotización
          </Typography>
          <Typography variant="body2" color="white">
            N°
          </Typography>
          <Typography variant="caption" color="white">
            
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
    <Box
      sx={{
        p: 4,
        bgcolor: '#fff',
        borderRadius: 2,
        boxShadow: 2,
        minWidth: 320,
        maxWidth,
        textAlign: 'center',
        mt: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  </Box>
);

export default PageLayout;
